import { render, staticRenderFns } from "./BannersPage.vue?vue&type=template&id=2393b74a&scoped=true"
import script from "./BannersPage.vue?vue&type=script&lang=js"
export * from "./BannersPage.vue?vue&type=script&lang=js"
import style0 from "./BannersPage.vue?vue&type=style&index=0&id=2393b74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2393b74a",
  null
  
)

export default component.exports